import { Component, OnInit,Inject, ViewChild, ChangeDetectorRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-promotions-file-edit',
  templateUrl: './promotions-file-edit.component.html',
  styleUrls: ['./promotions-file-edit.component.scss'],
  providers: [DatePipe]
})
export class PromotionsFileEditComponent implements OnInit {

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  isLoading = false;
  groupForm!: FormGroup;
  id_camp : number = 0;
  promotionFile : Array<any>= [];
  dspromotionFile: any = [];
  displayedColumns: string[] = [];
  allColumns: string[] = [];
  editing: any = {};
  workbook: any;
  fileName: string = '';
  originalPromotionFile: Array<any> = [];
  hasChanges: boolean = false;
  file_id : number = 0;
  codigosList: string = '';
  bodyForm : FormData = new FormData(); 
  folder : string = '';
  
  constructor(@Inject(MAT_DIALOG_DATA) public data : any,
 private projectsS: ProjectsService,
 private main: MainService,
 private datePipe: DatePipe,
 private dialogRef: MatDialogRef<PromotionsFileEditComponent>,
 private cdr: ChangeDetectorRef) { 
      this.id_camp = this.data.id_camp;
      this.folder = this.data.project.folder;
      this.preloadFormData();
      console.log(this.folder);
 }

  ngOnInit(): void {
    this.getPromoFile()

  }

  onSubmit(){
    console.log('test')
  }

  preloadFormData(){
    this.bodyForm.append('id_proj', this.id_camp.toString() as string); 
    this.bodyForm.append('folder', this.folder as string);      
  }

  getPromoFile(){
    this.main.ShowLoading();
    this.projectsS.getPromotionDownload(this.id_camp).subscribe(async (res: any) => {
   
        if (res.message === "Success") {
          this.fileName = res.fileName;
          this.file_id = res.file_id;
          this.bodyForm.append('id_file', this.file_id.toString() as string); 
          
          const base64String = res.data;
          console.log("fileid", this.file_id);
          
          this.workbook = XLSX.read(base64String, { type: 'base64', cellDates: true });
          const sheetName = this.workbook.SheetNames[0];
          const worksheet = this.workbook.Sheets[sheetName];
          
          const data: any[] = XLSX.utils.sheet_to_json(worksheet, { raw: true });
          data.forEach(row => {
            for (const key in row) {
              if (row[key] instanceof Date) {
                row[key] = this.datePipe.transform(row[key], 'yyyy-MM-dd');
              }
            }
          });

          this.promotionFile = data;
          this.originalPromotionFile = JSON.parse(JSON.stringify(data)); 
          this.hasChanges = false;
          this.dspromotionFile = new MatTableDataSource(this.promotionFile);
          this.dspromotionFile.paginator = this.paginator;
          this.dspromotionFile.sort = this.sort;

          if (this.promotionFile && this.promotionFile.length > 0) {
            this.displayedColumns = Object.keys(this.promotionFile[0]).filter(key => key && key.trim() !== '');
            this.allColumns = ['acciones', ...this.displayedColumns];
            
          }
        }
      
      this.main.HideLoading();
    }, (err:any) => {
      this.main.HideLoading();
      console.error(err);
      Swal.fire('Error', 'No se pudo cargar el archivo de promociones.', 'error');
    });
  } 

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dspromotionFile.filter = filterValue.trim().toLowerCase();
    if (this.dspromotionFile.paginator) this.dspromotionFile.paginator.firstPage();
  }

  editCell(rowIndex: number, column: string) {
    this.editing = { rowIndex, column };
  }

  finishEditing(event: any, rowIndex: number, column: string) {
    const newValue = event.target.value;
    this.dspromotionFile.data[rowIndex][column] = newValue;
    this.editing = {};
    this.hasChanges = true;
    this.cdr.detectChanges();
  }

  getCellType(value: any): string {
    if (value instanceof Date || /^\d{4}-\d{2}-\d{2}$/.test(value)){
      return 'date';
    } 
    if (typeof value === 'number'){
       return 'number';
    }
    return 'text';
  }

  async addRow() {
    const { value: codigoPrincipal } = await Swal.fire({
      title: "Agregar Nueva Fila",
      input: 'text',
      inputLabel: "CODIGO PRINCIPAL",
      inputPlaceholder: "Ingrese el CODIGO PRINCIPAL",
      showCancelButton: true,
      confirmButtonText: "Agregar",
      cancelButtonText: "Cancelar",
      inputValidator: (value: string) => {
        if (!value) {
          return "Necesitas ingresar un CODIGO PRINCIPAL";
        }
        return null;
      }
    });

    if (codigoPrincipal) {
      const newRow: any = { "CODIGO PRINCIPAL": codigoPrincipal };
      this.displayedColumns.forEach(col => {
        if (col !== "CODIGO PRINCIPAL") newRow[col] = null;
      });
      this.dspromotionFile.data = [newRow, ...this.dspromotionFile.data];
      this.hasChanges = true;
    }
  }

  addRowsFromList() {
    if (!this.codigosList || this.codigosList.trim() === '') {
      Swal.fire("Lista vacía", "Por favor ingrese una lista de códigos.", 'info');
      return;
    }

    const codigos = this.codigosList.split(',').map(c => c.trim()).filter(c => c !== '');

    if (codigos.length === 0) {
      Swal.fire("Lista vacía", "No se encontraron códigos válidos en la lista.", 'info');
      return;
    }

    const newRows = codigos.map(codigoPrincipal => {
      const newRow: any = { "CODIGO PRINCIPAL": codigoPrincipal };
      this.displayedColumns.forEach(col => {
        if (col !== "CODIGO PRINCIPAL") {
          newRow[col] = null;
        }
      });
      return newRow;
    });

    this.dspromotionFile.data = [...newRows, ...this.dspromotionFile.data];
    this.hasChanges = true;
    this.codigosList = ''; 
    Swal.fire('Filas agregadas', `${newRows.length} fila(s) ha(n) sido agregada(s)`, 'success');
  }

  deleteRow(rowIndex: number, row: any) {
    const codigo = row['CODIGO PRINCIPAL'] || 'sin código';
    Swal.fire({
      title: '¿Está seguro?',
      html: `¿Desea eliminar esta fila con <b>CODIGO PRINCIPAL: ${codigo}</b>?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        const data = this.dspromotionFile.data;
        data.splice(rowIndex, 1);
        this.dspromotionFile.data = data;
        this.hasChanges = true;
      }
    });
  }

  revertChanges() {
    Swal.fire({
      title: '¿Revertir Cambios?',
      text: "Perderá todas las modificaciones no guardadas. ¿Desea continuar?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: "Sí, revertir",
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.promotionFile = JSON.parse(JSON.stringify(this.originalPromotionFile));
        this.dspromotionFile.data = this.promotionFile;
        this.hasChanges = false;
        Swal.fire('Revertido', 'Los cambios han sido descartados.', 'success');
      }
    });
  }

  downloadTemplate() {
    this.main.generateExcel([], 'Plantilla_Promociones', 'Plantilla', "", this.displayedColumns);
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const workbook = XLSX.read(e.target.result, { type: 'binary', cellDates: true });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const headers: string[] = (XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0] as string[]) || [];

      if (!headers.includes('CODIGO PRINCIPAL')) {
        Swal.fire('Error de formato', 'El archivo subido debe contener la columna "CODIGO PRINCIPAL".', 'error');
        return;
      }

      const uploadedData: any[] = XLSX.utils.sheet_to_json(worksheet, { raw: true });

      const newRows = uploadedData.map(uploadedRow => {
        const newRow: any = {};
        this.displayedColumns.forEach(col => {
          if (uploadedRow.hasOwnProperty(col)) {
            let value = uploadedRow[col];
            if (value instanceof Date) {
              newRow[col] = this.datePipe.transform(value, 'yyyy-MM-dd');
            } else {
              newRow[col] = value;
            }
          } else {
            newRow[col] = null;
          }
        });
        return newRow;
      });

      this.dspromotionFile.data = [...newRows, ...this.dspromotionFile.data];
      this.hasChanges = true;
      Swal.fire('Filas agregadas', `${newRows.length} fila(s) ha(n) sido agregada(s).`, 'success');
    };

    reader.readAsBinaryString(file);
    event.target.value = null; 
  }


  async saveChanges(){
    const result = await Swal.fire({
      title: '¿Guardar Cambios?',
      text: "Se guardará una nueva versión del archivo con las modificaciones realizadas.",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, guardar',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      this.main.ShowLoading();

      const dataToSave = this.dspromotionFile.data.map((row:any) => {
        const newRow: any = {};
        this.displayedColumns.forEach(col => {
          newRow[col] = row[col];
        });
        return newRow;
      });

      const newWorksheet = XLSX.utils.json_to_sheet(dataToSave);
      const newWorkbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, 'Promociones');

      const newWorkbookBuffer = XLSX.write(newWorkbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([newWorkbookBuffer], { type: 'application/octet-stream' });

      this.bodyForm.append('blob', blob, this.fileName);

      this.projectsS.editSheetPromociones(this.bodyForm).subscribe({
        next: (x: any) => {
          this.main.HideLoading();
          if (x.message == "Success") {
                       Swal.fire({
                         icon: 'success',
                         title: 'Archivo editado',
                         text: 'Archivo editado exitosamente'          
                       }).then(() => {            
                         this.dialogRef.close({ reload: true });
                       });  
          } else {
            Swal.fire('Error', 'Ocurrió un error al editar el archivo.', 'error');
          }
        },
        error: (err: any) => {
          this.main.HideLoading();
          console.error(err);
          Swal.fire('Error', 'Ocurrió un error al editar el archivo, por favor vuelve a intentarlo.', 'error');
        }
      });
    }
  }
}
